module.exports = __webpack_public_path__ + "img/ad_coupon.7c632362.png";